import { render, staticRenderFns } from "./VirtualAssistant.vue?vue&type=template&id=0a5fae78"
import script from "./VirtualAssistant.vue?vue&type=script&lang=js"
export * from "./VirtualAssistant.vue?vue&type=script&lang=js"
import style0 from "./VirtualAssistant.vue?vue&type=style&index=0&id=0a5fae78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports